import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var Crown = function Crown(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_jsx("svg", {
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M0.666656 4.39912L2.76189 13.6667H13.3167L15.3333 4.39912L11.1428 6.03031L7.99999 1.66667L4.85713 6.03031L0.666656 4.39912Z",
      stroke: "#00DAE8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};